import {
  CheckCircleOutlined,
  UserOutlined,
  BlockOutlined,
  CloseOutlined,
  CloseCircleFilled,
  ClockCircleOutlined,
} from '@ant-design/icons'
import { Space, Typography } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import type { IAccountStatusProps } from './types'

const { Text } = Typography

function AccountStatus({ status, date, approver }: IAccountStatusProps): JSX.Element {
  const { t } = useTranslation()

  function renderIconAccountStatus(accountStatus: string) {
    switch (accountStatus) {
      case 'APPROVED':
        return <CheckCircleOutlined className="primary-color" />
      case 'REJECTED':
        return <CloseCircleFilled className="danger-color" />
      case 'BLOCKED':
        return <BlockOutlined className="danger-color" />
      case 'CLOSED':
        return <CloseOutlined className="danger-color" />
      case 'PREPARING':
        return <ClockCircleOutlined className="reviewing-color" />
      default:
      case 'REVIEWING':
        return <UserOutlined className="reviewing-color" />
    }
  }

  function renderTextAccountStatus(accountStatus: string) {
    switch (accountStatus) {
      case 'APPROVED':
        return <Text className="primary-color">{t('organization:status.approved')}</Text>
      case 'REJECTED':
        return <Text className="danger-color">{t('organization:status.rejected')}</Text>
      case 'SUSPENDED':
        return <Text className="danger-color">{t('organization:status.suspended')}</Text>
      case 'CLOSED':
        return <Text className="danger-color">{t('organization:status.closed')}</Text>
      case 'PREPARING':
        return <Text className="reviewing-color">{t('organization:status.preparing')}</Text>
      case 'NEED_MORE_INFORMATION':
        return <Text className="reviewing-color">{t('organization:status.needMoreInformation')}</Text>
      default:
      case 'REVIEWING':
        return <Text className="reviewing-color">{t('organization:status.reviewing')}</Text>
    }
  }

  function renderApproveAccountStatus(accountStatus: string) {
    switch (accountStatus) {
      case 'APPROVED':
        return `on ${dayjs(date).format('D MMM YYYY HH:mm')} by ${approver}`
      case 'REJECTED':
        return `on ${dayjs(date).format('D MMM YYYY HH:mm')} by ${approver}`
      case 'SUSPENDED':
        return `on ${dayjs(date).format('D MMM YYYY HH:mm')} by ${approver}`
      case 'CLOSED':
        return `on ${dayjs(date).format('D MMM YYYY HH:mm')} by ${approver}`
      case 'PREPARING':
        return `on ${dayjs(date).format('D MMM YYYY HH:mm')}`
      case 'NEED_MORE_INFORMATION':
        return 'Please update additional information and submit again.'
      default:
      case 'REVIEWING':
        return 'Please wait for the review. If status has been changed. We will notify you by email.'
    }
  }

  return (
    <Space direction="vertical" size={0}>
      <Space size={16} align="center">
        {renderTextAccountStatus(status)}
        {renderIconAccountStatus(status)}
      </Space>
      <Text style={{ fontSize: 12 }} type="secondary">
        {renderApproveAccountStatus(status)}
      </Text>
    </Space>
  )
}

export default AccountStatus
